// extracted by mini-css-extract-plugin
module.exports = {"mapColumn":"FlexLanding_mapColumn__9X2cX","formColumn":"FlexLanding_formColumn__siMSK"};